import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import { Controller, UseFormTrigger } from 'react-hook-form';
import { CSSProperties } from 'react';

/**
 * CheckboxController component
 *
 * This component wraps a Material-UI Checkbox with react-hook-form's Controller
 * for easy form integration and state management.
 *
 * @param {Object} props - The component props
 * @param {any} props.control - The control object from react-hook-form
 * @param {string} props.name - The name of the form field
 * @param {string} props.label - The label for the checkbox
 * @param {CSSProperties} [props.style] - Optional custom styles for the FormControlLabel
 * @param {CheckboxProps} [props.etc] - Optional additional props for the Checkbox component
 * @returns {JSX.Element} A controlled Checkbox component
 */
const CheckboxController = ({
  control,
  name,
  label,
  style,
  etc,
  trigger,
  disabled,
  setValue,
}: {
  control: any;
  name: string;
  label: string;
  style?: CSSProperties;
  etc?: CheckboxProps;
  trigger?: UseFormTrigger<any>;
  disabled?: boolean;
  setValue?: (boolean) => void;
}) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                disabled={disabled}
                checked={!!field.value}
                onChange={(_e, checked) => {
                  field.onChange(checked);
                  setValue?.(checked);
                }}
                name={name}
                {...etc}
                onBlur={(event) => {
                  etc?.onBlur?.(event);

                  if (trigger) {
                    trigger(name);
                  }
                }}
              />
            }
            label={label}
            sx={[
              {
                width: '100%',
                m: 0,
              },
              style || {},
            ]}
          />
        )}
      />
    </>
  );
};

export default CheckboxController;
